// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/calculate-membership-request-schema',
  type: 'object',
  required: ['categoryKey'],
  properties: {
    categoryKey: {
      type: 'integer',
    },
    isMembershipReEntry: {
      type: 'boolean',
    },
    postalCode: {
      type: 'string',
    },
    postalCodeAddition: {
      type: 'string',
    },
  },
} as IJSONSchema;

export default schema;
